import React from "react";

export default function Angle({ position }) {
  const id = Math.floor(Math.random() * 100);
  const isBottomAngle = position === "bottom" ? "bottom-angle" : "";
  return (
    <div className={`angle-container ${isBottomAngle}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1592 500"
        version="1.1"
        className="angle"
        aria-hidden="true"
      >
        <defs>
          <rect id={`path-1-${id}`} x={0} y={0} width={1600} height={500} />
          <polygon
            id={`path-3-${id}`}
            points="0 0.255013812 3200 0.255013812 3200 1670.59548 0 1670.59548"
          />
        </defs>
        <g
          id={`Page-1-${id}`}
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
        >
          <g id={`Group-3-${id}`}>
            <mask id={`mask-2-${id}`} fill="white">
              <use xlinkHref={`#path-1-${id}`} />
            </mask>
            <g id={`Mask-${id}`} />
            <g mask={`url(#mask-2-${id}`}>
              <g transform="translate(-1600.000000, -1171.000000)">
                <mask id={`mask-4-${id}`} fill="white">
                  <use xlinkHref={`#path-3-${id}`} />
                </mask>
                <g id={`Clip-2-${id}`} stroke="none" fill="none" />
                <path
                  d="M146.52994,379.720829 C65.8716293,400.721978 0,452.44669 0.0810229143,494.558845 L0.0810229143,511.129063 L0,511.129063 L0,1176.57435 L0.0405114571,1176.57435 C0.0405114571,1200.798 21.9977212,1228.1709 56.0678567,1251.16779 C81.0634258,1267.97604 112.540828,1282.40403 146.691986,1291.30251 L1116.49576,1544.37825 L1453.51057,1632.2828 C1454.07773,1632.4842 1454.84745,1632.61237 1455.45512,1632.79547 L1456.1033,1632.92364 C1456.71098,1633.0518 1457.27814,1633.17997 1457.8453,1633.32645 L1599.87847,1670.40345 L1599.91898,1670.44007 L1600,1670.44007 L1742.23573,1633.32645 C1742.76237,1633.17997 1743.41056,1633.03349 1743.93721,1632.92364 L1744.58539,1632.79547 C1745.19306,1632.63068 1745.96278,1632.46589 1746.61096,1632.2828 L2066.97557,1548.68102 L3053.42955,1291.2842 C3088.47196,1282.14769 3120.75959,1267.20703 3146.07925,1249.79457 C3178.97455,1227.14556 3200,1200.30364 3200,1176.57435 L3199.91898,494.558845 C3200,480.515357 3192.50538,465.354981 3179.74427,450.652346 C3154.14103,421.338624 3107.18825,393.746008 3053.42955,379.70252 L3053.30801,379.739139 L3053.38904,379.70252 L1746.7325,38.7771598 C1746.61096,38.7222309 1746.48943,38.7222309 1746.24636,38.7222309 L1599.91898,0.510027625 L1599.91898,0.510027625 L1453.87517,38.6489924 C1453.67262,38.6856117 1453.55108,38.7405406 1453.38904,38.7405406 L146.52994,379.70252 L1613.87856,1855.4805"
                  id={`Fill-1-${id}`}
                  stroke="none"
                  fill="#074050"
                  fillRule="evenodd"
                  mask={`url(#mask-4-${id}`}
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}
